import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom'
import { makeStyles, withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import { ptBR } from '@material-ui/core/locale';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Swal from 'sweetalert2'
import Checkbox from '@material-ui/core/Checkbox';
import withReactContent from 'sweetalert2-react-content'
import { Icon } from "react-icons-kit";
import { ic_delete } from "react-icons-kit/md/ic_delete";
import { ic_mode_edit } from "react-icons-kit/md/ic_mode_edit";
import { folderDownload } from 'react-icons-kit/icomoon/folderDownload'
import FrLoading from '../FrLoading'
import download from 'downloadjs'

import api from '../../services/api'

import './index.css';


const swal = withReactContent(Swal)

const theme = createMuiTheme({
  palette: {
    primary: { main: '#1976d2' },
  },
}, ptBR);

const FrCheckBox = withStyles({
  root: {
    color: 'black',
    '&$checked': {
      color: 'black',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);



const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: '#beccaf'
    },
    "& .Mui-selected:hover": {
      backgroundColor: '#beccaf'
    },
    width: '100%',
  },
  container: {
    maxHeight: '58vh',
    minHeight: '58vh'
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#F1873B',
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);



export default function FrTable(props) {
  const classes = useStyles();
  const createSortHandler = (property) => (event) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  let history = useHistory();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [data, setData] = useState(props.data)
  const [columns, setColumns] = useState(props.columns)
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState(props.columns[0].id);

  useEffect(()=>{
    setData(props.data)
    setPage(0)
  }, [props.data])

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  function handleEdit(e, row) {
    e.preventDefault();
    console.log(row)

    if (props.setArq_Nome) props.setArq_Nome(row["nome"]);
    if (props.setArq_Codigo) props.setArq_Codigo(row["codigo"]);

    props.setPkModal(row["pk"]);
    props.setUpdateModal(true);
    props.setModal(true);
  }

  function handleDelete(e, id, table) {
    e.preventDefault()
    swal.fire({
      title: 'ATENÇÃO',
      text: "Deseja excluir PERMANENTEMENTE o registro selecionado?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não'
    }).then((result) => {
      if (result.value) {
        api.post('/'+table+'/delete/'+id).then(r=>{
          if (r.status === 200) {
            swal.fire({
              title: 'Registro Excluído',
              text: "O registro foi excluído com sucesso!",
              icon: 'success',
            }).then((result) => {
              if (result.value) {
                window.location.reload()
              }
            })
          } else {
            swal.fire({
              title: 'Erro!',
              text: "O registro não foi excluído!",
              icon: 'warning',
            })
          }
        })
      }
    })
  }

  function handleDownload(e, name, pk){

    var foundData = false
    swal.fire({
      html: <FrLoading text="Em Processamento..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/propostas/downloadArquivo?fk_prp=' + name.fk_prp+'&nome='+name.nome,  {responseType: 'blob'}).then(r => {
      let name = 'arquivo.pdf'  
      let type = 'applicaton/pdf'
      if (r.data.size>0){
        foundData=true
      }
      var blob = new Blob([r.data], {
        type: type
        });
        download(blob, name)
        swal.close()
    })
    setTimeout(() => {
      if(!foundData){
        swal.fire({
          title: 'Atenção!',
          text: "arquivo não foi encontrado!",
          icon: 'warning',
        })
      } else {
        swal.close()
      }
    }, 8000)

  }

  function handleDeleteArq(e, name, pk) {
    e.preventDefault();
    swal
      .fire({
        title: "ATENÇÃO",
        text: "Deseja excluir o registro selecionado?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
      })
      .then((result) => {
        if (result.value) {
          var sliced = [];
          var excluidos = [];

          for (var i = 0; i < data.length; i++)
            if (pk > 0) {
              if (data[i].pk !== pk && data[i].pk > 0) {
                sliced.push(data[i]);
                if ((pk > 0) && (props.arrayExcluidos)) {
                  for (var x = 0; x < props.arrayExcluidos.length; x++) {
                    excluidos.push(props.arrayExcluidos[x])
                  }
                  excluidos.push(pk)
                  props.setArrayExcluidos(excluidos)
                }

              }
            } else {
              if (data[i].display !== name && data[i].display !== "") {
                sliced.push({
                  value: data[i].value,
                  display: data[i].display,
                });
              }
            }
          if (sliced.length === 0) {
            sliced.push({
              value: "",
              display: "",
              pk: 0,
            });
          }

          if (props.setDataDoe) {
            props.setDataDoe(sliced);
          }

          if (props.setDataGrid) {
            props.setDataGrid(sliced);
          }
        }
      });
  }


  const handleClick = (event, name) => {
    console.log(name)
    history.push('/sistema/'+props.regName+'/registro?codigo='+name)

  };


  return (
      <ThemeProvider theme={theme}>
        {(data.length === 0) ? (
          <div>{props.searched ? props.emptyMessage : ''}</div>
        ) : (
          <Paper className={classes.root}>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                  {!props.readonly ? (
                    <StyledTableCell
                      style={{ minWidth: 100, width: 100 }}
                    ></StyledTableCell>
                  ) : (
                    <></>
                  )}
                    {columns.map((column) => (
                      <StyledTableCell
                        key={column.id}
                        align={column.align}
                        style={{ minWidth: column.minWidth }}
                      >
                        <TableSortLabel
                          active={orderBy === column.id}
                          direction={orderBy === column.id ? order : 'asc'}
                          onClick={createSortHandler(column.id)}
                        >
                          {column.label}
                        </TableSortLabel>
                      </StyledTableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stableSort(data, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const labelId = `enhanced-table-checkbox-${index}`;
                    return (
                      <TableRow onClick={(event) => handleClick(event, row[props.codeName])} hover tabIndex={-1} key={row[props.codeName]}>
                        {!props.readonly &&
                          (row[props.codeName] !== "" || row["pk"] > 0) ? (
                          <TableCell>
                            {props.regName == 'propostaAssociado' ?
                              <Icon
                              className="tableDelete"
                              icon={ic_delete}
                              size={18}
                              onClick={(e) =>
                                handleDeleteArq(e, row[props.codeName], row["pk"])
                              }
                            />:
                            <Icon
                              className="tableDelete"
                              icon={ic_delete}
                              size={18}
                              onClick={(e) =>
                                handleDelete(e, row[props.codeName], row["pk"])
                              }
                            />
                            }
                            {props.editar ? (
                              <Icon
                                className="tableDelete"
                                icon={ic_mode_edit}
                                size={18}
                                onClick={(e) => handleEdit(e, row)}
                              />
                            ) : (
                              <></>
                            )}
                            {props.download ? (
                              <Icon
                                className="tableDelete"
                                icon={folderDownload}
                                size={18}
                                onClick={(e) => handleDownload(e, row)}
                              />
                            ) : (
                              <></>
                            )}
                          </TableCell>
                        ) : (
                          <></>
                        )}
                        {columns.map((column) => {
                          const value = row[column.id];
                          if (column.image) {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                <img src={value ? api.backendUrl+'/static/upload/lotes/'+row[props.codeName]+'/'+value : api.backendUrl+'/static/upload/lotes/no-image.jpg'} style={{ maxHeight: '60px'}}/>
                              </TableCell>
                            )
                          } else {
                            return (
                              <TableCell key={column.id} align={column.align}>
                                {column.format && typeof value === 'number' ? column.format(value) : value}
                              </TableCell>
                            );
                          }
                        })}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>
        )}
    </ThemeProvider>
  );
}
